import { Box, Button, Paper, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface ImposterPassStepProps {
  currentPlayerIndex: number;
  onNext: () => void;
}

const ImposterPassStep: React.FC<ImposterPassStepProps> = ({
  currentPlayerIndex,
  onNext,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const neonPalette = (theme.palette as any).neon;

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: theme.palette.background.paper,
        border: `4px solid ${neonPalette.aqua}`,
        borderRadius: 3,
        boxShadow: `0 8px 32px ${neonPalette.aqua}60, 0 4px 16px ${neonPalette.aqua}30, inset 0 0 20px ${neonPalette.aquaLight}20`,
        overflow: "visible",
      }}
    >
      <Box sx={{ p: 4 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: theme.palette.text.primary,
            textAlign: "center",
            mb: 4,
            background: `linear-gradient(135deg, ${neonPalette.aqua} 0%, ${neonPalette.cyan} 100%)`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          {t("imposter.passToNext")}
        </Typography>

        <Paper
          elevation={0}
          sx={{
            mb: 4,
            p: 2,
            backgroundColor: neonPalette.aquaLight,
            border: `2px solid ${neonPalette.aqua}`,
            borderRadius: 2,
            boxShadow: `0 4px 12px ${neonPalette.aqua}40`,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: theme.palette.text.primary,
              textAlign: "center",
            }}
          >
            {t("imposter.passToPlayer")} {currentPlayerIndex + 2}
          </Typography>
        </Paper>

        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={onNext}
          sx={{
            py: 3,
            background: `linear-gradient(135deg, ${neonPalette.yellow} 0%, ${neonPalette.yellowDark} 100%)`,
            color: theme.palette.text.primary,
            fontWeight: 700,
            fontSize: "1.25rem",
            borderRadius: 2,
            boxShadow: `0 4px 16px ${neonPalette.yellow}60, 0 2px 8px ${neonPalette.yellow}30`,
            "&:hover": {
              background: `linear-gradient(135deg, ${neonPalette.yellowDark} 0%, ${neonPalette.yellow} 100%)`,
              boxShadow: `0 6px 20px ${neonPalette.yellow}80, 0 3px 10px ${neonPalette.yellow}40`,
              transform: "translateY(-2px)",
            },
            transition: "all 0.3s ease",
          }}
        >
          {t("common.next")}
        </Button>
      </Box>
    </Paper>
  );
};

export default ImposterPassStep;
